import { Component, OnInit, HostListener } from '@angular/core';
import { DialogService } from "../dialog/index";
import { DialogComponent } from "../dialog/dialog.component";
import { InSalesService } from '../../../shared/services/inventory/in-sales.service'
import { DataService } from '../../services/data.service'
export interface SalesHistoryModel {
  title: string;
  data: any;
}
@Component({
  selector: 'app-saleshistory-popup',
  templateUrl: './saleshistory-popup.component.html',
  styleUrls: ['./saleshistory-popup.component.css']
})
export class SalesHistoryPopupComponent extends DialogComponent<SalesHistoryModel, boolean> implements SalesHistoryModel, OnInit {
  title: string;
  data: any = {};
  model = new BackofficeSalesHistory_Master();
  result: any = { result: false, RtnItem: {} };
  loading: boolean = false;
  InclusiveVATInSales: boolean = false;
  ItemVAT: boolean = false;
  SalesHistoryOnBackofficeSale: boolean = false;
  HideCostPrice: boolean = false;
  ShowMinNoOfSalesOnHistory: boolean = false;
  ShowStockListOnSalesHistory: boolean = false;

  constructor(dialogService: DialogService, private ds: DataService, private sa: InSalesService) { super(dialogService); }

  ngOnInit() {
    this.model = new BackofficeSalesHistory_Master();

    var incv = (this.ds.Settings.InclusiveVATInSales)
    this.InclusiveVATInSales = incv.toLowerCase() == 'true'

    var iw = this.ds.Settings.Itemwisevat
    this.ItemVAT = iw.toLowerCase() == 'true'

    var sh = this.ds.Settings.SalesHistoryOnBackofficeSale
    this.SalesHistoryOnBackofficeSale = sh.toLowerCase() == 'true'

    var sm = this.ds.Settings.ShowMinNoOfSalesOnHistory
    this.ShowMinNoOfSalesOnHistory = sm.toLowerCase() == 'true'

    var sk = this.ds.Settings.ShowStockListOnSalesHistory
    this.ShowStockListOnSalesHistory = sk.toLowerCase() == 'true'

    if (this.data != "") {
      this.getHistoryForBackOfficeSales();
    }
  }

  @HostListener('window:keydown', ['$event']) KeyEventsPlugin(
    e: KeyboardEvent) {
    if (e.altKey) {
      switch (e.keyCode) {
        case 72:
          this.HideCostPrice = !this.HideCostPrice;
          break;
      }
    }
  }

  getHistoryForBackOfficeSales(ShowAll: boolean = false) {
    if (this.SalesHistoryOnBackofficeSale) {
      var data = {
        ItemId: 0,
        Barcode: this.data.Barcode,
        LocationId: this.ds.Settings.LocationId,
        BranchId: this.ds.Settings.BranchId,
        SalesId: this.data.SalesId,
        CustomerId: this.data.CustomerId,
        UserId: this.ds.Settings.UserId,
        ShowMinNoOfSalesOnHistory: this.ShowMinNoOfSalesOnHistory,
        ShowAll: ShowAll,
        CompanyId: this.ds.Settings.CompanyId,
        ShowStockListOnSalesHistory: this.ShowStockListOnSalesHistory
      }
      this.loading = true;
      this.sa.Get_HistoryForBackOfficeSales(data).subscribe(res => {
        if (res.Success) {
          this.model = res.data;
          this.calculateTax();
          this.loading = false;
        }
        else {
          alert(res.error.UsrMsg);
          this.loading = false;
        }
      })
    }
  }

  calculateTax() {
    let ItemTax: number = 0.0
    let rateamt: number = 0.0
    let ItemVatAmt: number = 0.0

    rateamt = (Number(this.data.Qty) * Number(this.data.Rate)) - Number(this.data.Discout)

    if (this.ItemVAT) {
      ItemTax = Number(this.model.TaxRate)
      if (this.InclusiveVATInSales) {

        ItemVatAmt = Number(rateamt) - (Number(rateamt) / (1 + (ItemTax / 100)))
      }
      else {
        ItemVatAmt = (Number(rateamt) * ItemTax) / 100
        rateamt = Number(rateamt) + Number(ItemVatAmt)
      }
    }
    else {
      ItemTax = Number(this.ds.Settings.VATPersentage)
      if (this.InclusiveVATInSales) {
        ItemVatAmt = Number(rateamt) - (Number(rateamt) / (1 + (ItemTax / 100)))
      }
      else {
        ItemVatAmt = (Number(rateamt) * ItemTax) / 100
        rateamt = Number(rateamt) + Number(ItemVatAmt)
      }
    }

    this.model.Tax = ItemVatAmt
    this.model.Total = rateamt
  }

  ok() {
    this.close();
  }

  ShowMore() {
    if (this.data != "" && this.model.HistoryList.length > 0) {
      this.getHistoryForBackOfficeSales(true);
    }
  }

}

class BackofficeSalesHistory_Master {
  Id: number = 0
  Barcode: string = ""
  ItemName: string = ""
  ItemId: number = 0
  Unit: string = ""
  Contain: number = 0
  TaxRate: number = 0
  Tax: number = 0
  Total: number = 0
  StkQty: number = 0
  CostPrice: number = 0
  SellingPrice: number = 0
  HistoryList: BackofficeSalesHistory_Detail[] = [];
  UserDetails: BackofficeSalesHistory_UserDetail = new BackofficeSalesHistory_UserDetail;
  LocationStockList: BOStockHistory_Master[] = [];
}

class BackofficeSalesHistory_Detail {
  InvNo: string = ""
  InvDate: Date = new Date()
  Customer: string = ""
  Qty: number = 0
  Rate: number = 0
  Total: number = 0
  SalesMan: string = ""
}

class BackofficeSalesHistory_UserDetail {
  CreatedUser: string = ""
  CreatedDate: Date = new Date()
  ModifiedUser: string = ""
  ModifiedDate: Date = new Date()
}

class BOStockHistory_Master {
  Location: string = "";
  Qty: number = 0;
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/saleshistory-popup/saleshistory-popup.component.ts